export default "__VITE_ASSET__DFq$IQOW__"